// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"076a921a","300":"dd5a952d","493":"59217f87","930":"1a7c2b93"}[chunkId] + ".4cbf9dcb6dd3f1cb5d733a494c57de7d31d9b0a8.chunk.js";
};